import { EmoticonConfusedIcon } from './EmoticonConfusedIcon';

/**
 * author: Michael Richins
 * id DD5A65E9-E309-457F-9662-94AAB236A703
 * name emoticon-confused
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-confused.svg
 * tags
 * - Emoji 
 */
export const EmojiConfusedIcon = EmoticonConfusedIcon;
export default EmojiConfusedIcon